export default __webpack_public_path__ + "static/media/copy-outline.fd05df59.svg";